import Address from "./Address";
import withAutoComplete from "./withAutoComplete";

export default withAutoComplete(Address);
